import {reactive} from "vue";

class MetaVendaEvents {
    
    listenerMetaVendaGravada = reactive({value: {metaVendaId: ''}})
    listenerMetaVendaAlterada = reactive({value: {metaVendaId: ''}})
    listenerMetaVendaRemovida = reactive({value: {metaVendaId: ''}})

    emitMetaVendaGravada(metaVendaId: string) {
        this.listenerMetaVendaGravada.value = {metaVendaId: metaVendaId}
    }

    emitMetaVendaAlterada(metaVendaId: string) {
        this.listenerMetaVendaAlterada.value = {metaVendaId: metaVendaId}
    }

    emitMetaVendaRemovida(metaVendaId: string) {
        this.listenerMetaVendaRemovida.value = {metaVendaId: metaVendaId}
    }
    

}

export default MetaVendaEvents;